import { push } from 'redux-first-history'

export default function pushRouterAction () {
  return push(...arguments)
}
